module.exports = __webpack_public_path__ + "media/bootstrap-icons/dice-3-9f8deb1e.svg";